import $ from 'jquery';
import JQueryView, { on } from '../../../../../common/views/jqueryView';

export default class IndexView extends JQueryView {
  constructor() {
    super('#index_view');
    this.render();
  }

  @on({ event: 'click', selector: '.dropdown-menu' })
  onClickDropdownMenu(event: JQuery.ClickEvent) {
    event.stopPropagation();
  }

  @on({ event: 'click', selector: '.selection' })
  onClickSelection() {
    this.render();
  }

  render() {
    let statuses = '';
    $('input[name="q[status_eq_any][]"]').each((index, element) => {
      if ($(element).prop('checked') === true) {
        statuses += $(element).parent('label').text();
        statuses += ',';
      }
    });
    if (statuses !== '') {
      $('#drop_link').text(statuses.replace(/\s/g, '').slice(0, -1));
    } else {
      $('#drop_link').text('ステータスで絞り込み');
    }
  }
}
